import type { PopoverConfig } from './popover-registry';

/**
 * Manager for popovers.
 */
export interface PopoverManager {
    /**
     * Show a popover.
     * @param reference - The reference element.
     * @param config - The configuration for the popover.
     */
    showPopover(reference: HTMLElement, config: PopoverConfig): void;
    /**
     * Hide the current popover.
     */
    hideCurrentPopover(): void;
}

export const PopoverManager = Symbol('PopoverManager');
